<template>
  <a :class="iconButtonClasses" :href="href" @click.prevent v-on="scrollTopHandler ? { click: scrollToTop } : {}">
    <span class="text">{{ text }}</span>
    <svg v-if="icon == 'ticket'" class="icon icon--ticket" fill="currentColor" width="24" height="23" viewBox="0 0 24 23" xmlns="http://www.w3.org/2000/svg">
      <path d="M20.987 6.431c-1.098.655-2.538.511-3.483-.434-.946-.945-1.089-2.386-.434-3.483l-2.512-2.513-14.057 14.059 2.451 2.451c1.115-1.115 2.925-1.115 4.04 0 1.115 1.115 1.115 2.924 0 4.04l2.451 2.451 14.058-14.056-2.513-2.513" fill-rule="nonzero" />
    </svg>
    <i v-else class="icon material-icons">{{ icon }}</i>
  </a>
</template>
<script>
export default {
  props: {
    scrollTopHandler: { type: Boolean, default: false },
    icon: { type: String, required: true },
    text: { type: String, required: true },
    href: { type: String, required: true },
    subClasses: { type: Array, required: false }
  },
  created() {},
  data() {
    return {};
  },
  computed: {
    iconButtonClasses() {
      const baseClass = 'mu-icon-btn';
      const shortName = 'mib';
      const muTheme = 'war';
      const classes = [];
      // ***
      classes.push(baseClass);
      classes.push(shortName);
      classes.push(`${shortName}--${muTheme}`);
      if (this.subClasses) {
        this.subClasses.forEach((subClass) => {
          classes.push(`${shortName}--${subClass}`);
        });
      }
      return classes.join(' ');
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    }
  }
};
</script>